export class MockedRoomControlFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.temperature.levels.comfort.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.temperature.levels.comfort.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.temperature.levels.comfort.perceived',
        timestamp: '2023-03-23T11:39:08.842Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          activated: {
            type: 'array',
            value: [],
          },
          supported: {
            type: 'array',
            value: [
              'supplyChannel0FTDC',
              'supplyChannel1FTDC',
              'supplyChannel2FTDC',
              'supplyChannel3FTDC',
              'supplyChannel0FTDCUseValveInformation',
              'supplyChannel1FTDCUseValveInformation',
              'supplyChannel2FTDCUseValveInformation',
              'supplyChannel3FTDCUseValveInformation',
              'remotePresenceProbability',
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features',
        gatewayId: gatewaySerial,
        feature: 'rooms.features',
        timestamp: '2023-03-25T16:20:06.344Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.quickmodes.manualTillNextSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.quickmodes.manualTillNextSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.quickmodes.manualTillNextSchedule/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.quickmodes.manualTillNextSchedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.quickmodes.manualTillNextSchedule',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.temperature.levels.reduced.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.temperature.levels.reduced.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.temperature.levels.reduced.perceived',
        timestamp: '2023-03-23T11:39:08.842Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.reduced.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.reduced.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.temperature.levels.reduced.perceived',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.sensors.humidity',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.sensors.humidity',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.14.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.14.condensationRisk',
        timestamp: '2023-03-23T11:39:08.842Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.normalEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.normalEnergySaving',
        timestamp: '2023-03-26T04:00:07.175Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.operating.programs.reducedHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.reducedHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.reducedHeating',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: ['heating', 'ventilation'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.capability',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.capability',
        timestamp: '2023-03-23T11:39:08.842Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.operating.programs.comfortHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.comfortHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.comfortHeating',
        timestamp: '2023-03-23T11:39:08.842Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: ['heating'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.capability',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.capability',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.temperature.levels.normal.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.temperature.levels.normal.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.temperature.levels.normal.perceived',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.temperature.levels.comfort.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.temperature.levels.comfort.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.temperature.levels.comfort.perceived',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          actors: {
            value: [
              {
                deviceId: 'zigbee-84fd27fffed06d66',
                heatingCircuit: 0,
              },
              {
                deviceId: 'zigbee-b4e3f9fffe591980',
                heatingCircuit: 0,
              },
            ],
            type: 'array',
          },
          type: {
            value: 'livingroom',
            type: 'string',
          },
          name: {
            value: 'Living Room',
            type: 'string',
          },
        },
        commands: {
          addActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3/commands/addActor',
            name: 'addActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              heatingCircuit: {
                type: 'number',
                constraints: {},
                required: false,
              },
            },
          },
          moveActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3/commands/moveActor',
            name: 'moveActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              heatingCircuit: {
                type: 'number',
                constraints: {},
                required: false,
              },
              newRoomId: {
                type: 'number',
                constraints: {},
                required: true,
              },
            },
          },
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\p{L}0-9]+( [\\p{L}0-9]+)*$',
                  minLength: 1,
                  maxLength: 40,
                },
              },
            },
          },
          setType: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3/commands/setType',
            name: 'setType',
            isExecutable: true,
            params: {
              type: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'bathroom',
                    'bedroom',
                    'hallway',
                    'livingroom',
                    'kitchen',
                    'office',
                    'nursery',
                    'toilet',
                    'other',
                  ],
                },
              },
            },
          },
          removeActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3/commands/removeActor',
            name: 'removeActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
            },
          },
          remove: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3/commands/remove',
            name: 'remove',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3',
        gatewayId: gatewaySerial,
        feature: 'rooms.3',
        timestamp: '2023-03-26T04:06:42.260Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          variant: {
            value: 'full',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.status/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.status/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.status',
        gatewayId: gatewaySerial,
        feature: 'rooms.status',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          concentration: {
            type: 'number',
            value: 1000,
            unit: 'partsPerMillion',
          },
        },
        commands: {
          setConcentration: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.co2/commands/setConcentration',
            name: 'setConcentration',
            isExecutable: true,
            params: {
              concentration: {
                required: true,
                constraints: {
                  min: 400,
                  max: 1500,
                  stepping: 100,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.co2',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.condensationRisk',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.12.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.12.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 22,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.comfort.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.temperature.levels.comfort.heating',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.comfortEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.comfortEnergySaving',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          level: {
            type: 'string',
            value: 'normal',
          },
          demand: {
            type: 'string',
            value: 'energySaving',
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          modifier: {
            type: 'string',
            value: 'none',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.state',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.state',
        timestamp: '2023-03-26T04:00:07.176Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 20,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.temperature.levels.normal.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.temperature.levels.normal.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'Floor',
            type: 'string',
          },
          heatingCircuit: {
            value: 1,
            unit: '',
            type: 'number',
          },
          actors: {
            value: [],
            type: 'array',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
          addActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1/commands/addActor',
            name: 'addActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
            },
          },
          moveActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1/commands/moveActor',
            name: 'moveActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              newRoomId: {
                type: 'number',
                constraints: {},
                required: true,
              },
            },
          },
          removeActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1/commands/removeActor',
            name: 'removeActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1',
        timestamp: '2023-03-26T04:06:42.309Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 22,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.temperature.levels.comfort.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.temperature.levels.comfort.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.standby',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          concentration: {
            type: 'number',
            value: 1000,
            unit: 'partsPerMillion',
          },
        },
        commands: {
          setConcentration: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.co2/commands/setConcentration',
            name: 'setConcentration',
            isExecutable: true,
            params: {
              concentration: {
                required: true,
                constraints: {
                  min: 400,
                  max: 1500,
                  stepping: 100,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.co2',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.operating.programs.comfortHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.comfortHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.comfortHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'normalEnergySaving',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.active',
        timestamp: '2023-03-26T04:00:07.174Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.configuration.openWindow/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.configuration.openWindow/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.configuration.openWindow',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.configuration.openWindow',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.18.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.18.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.5.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.5.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.configuration.openWindow/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.configuration.openWindow/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.configuration.openWindow',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.configuration.openWindow',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.sensors.temperature',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.sensors.temperature',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.standby',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel1FTDC/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel1FTDC/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel1FTDC',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel1FTDC',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.condensationRisk',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 20,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.normal.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.temperature.levels.normal.heating',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.remotePresenceProbability/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.remotePresenceProbability/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.remotePresenceProbability',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.remotePresenceProbability',
        timestamp: '2023-03-25T16:20:06.339Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 20,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.normal.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.temperature.levels.normal.heating',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.standby',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.sensors.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.sensors.co2',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'reducedEnergySaving',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.active',
        timestamp: '2023-03-24T21:39:39.404Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.configuration.openWindow/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.configuration.openWindow/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.configuration.openWindow',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.configuration.openWindow',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'normalEnergySaving',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.active',
        timestamp: '2023-03-26T04:00:06.205Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.operating.programs.normalHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.normalHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.normalHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.standaloneMode',
        gatewayId: gatewaySerial,
        feature: 'rooms.standaloneMode',
        timestamp: '2023-03-25T16:20:06.340Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.manualTillNextScheduleEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.manualTillNextScheduleEnergySaving',
        timestamp: '2023-03-23T11:39:30.911Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.operating.programs.comfortHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.comfortHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.comfortHeating',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          actors: {
            value: [
              {
                deviceId: 'zigbee-b4e3f9fffee4b044',
                heatingCircuit: 0,
              },
            ],
            type: 'array',
          },
          type: {
            value: 'bathroom',
            type: 'string',
          },
          name: {
            value: 'Bathroom',
            type: 'string',
          },
        },
        commands: {
          addActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2/commands/addActor',
            name: 'addActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              heatingCircuit: {
                type: 'number',
                constraints: {},
                required: false,
              },
            },
          },
          moveActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2/commands/moveActor',
            name: 'moveActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              heatingCircuit: {
                type: 'number',
                constraints: {},
                required: false,
              },
              newRoomId: {
                type: 'number',
                constraints: {},
                required: true,
              },
            },
          },
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\p{L}0-9]+( [\\p{L}0-9]+)*$',
                  minLength: 1,
                  maxLength: 40,
                },
              },
            },
          },
          setType: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2/commands/setType',
            name: 'setType',
            isExecutable: true,
            params: {
              type: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'bathroom',
                    'bedroom',
                    'hallway',
                    'livingroom',
                    'kitchen',
                    'office',
                    'nursery',
                    'toilet',
                    'other',
                  ],
                },
              },
            },
          },
          removeActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2/commands/removeActor',
            name: 'removeActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
            },
          },
          remove: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2/commands/remove',
            name: 'remove',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2',
        gatewayId: gatewaySerial,
        feature: 'rooms.2',
        timestamp: '2023-03-26T04:06:42.260Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 8,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.comfort.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.comfort.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.temperature.levels.comfort.perceived',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.operating.programs.normalHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.normalHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.normalHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.normalEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.normalEnergySaving',
        timestamp: '2023-03-26T04:00:07.175Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.temperature.levels.reduced.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.temperature.levels.reduced.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.temperature.levels.reduced.perceived',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel1FTDCUseValveInformation/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel1FTDCUseValveInformation/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel1FTDCUseValveInformation',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel1FTDCUseValveInformation',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.9.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.9.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.operating.programs.manualTillNextScheduleHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.operating.programs.manualTillNextScheduleHeating/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.operating.programs.manualTillNextScheduleHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.manualTillNextScheduleHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.manualTillNextScheduleHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.reduced.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.reduced.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.temperature.levels.reduced.perceived',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.19.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.19.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.temperature.levels.reduced.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.temperature.levels.reduced.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.temperature.levels.reduced.perceived',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.operating.programs.manualTillNextScheduleHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.operating.programs.manualTillNextScheduleHeating/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.operating.programs.manualTillNextScheduleHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.manualTillNextScheduleHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.manualTillNextScheduleHeating',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '07:00',
                  end: '22:40',
                  position: 0,
                },
              ],
              sat: [],
              sun: [],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.schedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.schedule',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 24,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.temperature.levels.comfort.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.temperature.levels.comfort.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.temperature.levels.comfort.perceived',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.operating.programs.reducedHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.reducedHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.reducedHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 18,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.temperature.levels.reduced.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.temperature.levels.reduced.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-26T04:00:07.176Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'Radiator',
            type: 'string',
          },
          heatingCircuit: {
            value: 0,
            unit: '',
            type: 'number',
          },
          actors: {
            value: [],
            type: 'array',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
          addActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0/commands/addActor',
            name: 'addActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
            },
          },
          moveActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0/commands/moveActor',
            name: 'moveActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              newRoomId: {
                type: 'number',
                constraints: {},
                required: true,
              },
            },
          },
          removeActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0/commands/removeActor',
            name: 'removeActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0',
        timestamp: '2023-03-26T04:06:42.309Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.opd.activity',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.opd.activity',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-24T21:39:39.407Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          level: {
            type: 'string',
            value: 'reduced',
          },
          demand: {
            type: 'string',
            value: 'energySaving',
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          modifier: {
            type: 'string',
            value: 'none',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.state',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.state',
        timestamp: '2023-03-26T06:29:34.198Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.operating.programs.reducedHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.reducedHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.reducedHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'reducedEnergySaving',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.active',
        timestamp: '2023-03-26T06:29:34.196Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.quickmodes.manualTillNextSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.quickmodes.manualTillNextSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.quickmodes.manualTillNextSchedule/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.quickmodes.manualTillNextSchedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.quickmodes.manualTillNextSchedule',
        timestamp: '2023-03-24T14:29:39.235Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 20,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.temperature.levels.normal.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.temperature.levels.normal.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 18,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.temperature.levels.reduced.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.temperature.levels.reduced.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: ['heating'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.capability',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.capability',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.sensors.humidity',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.sensors.humidity',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.schedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.schedule',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: ['heating', 'ventilation'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.capability',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.capability',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.quickmodes.manualTillNextSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.quickmodes.manualTillNextSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.quickmodes.manualTillNextSchedule/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.quickmodes.manualTillNextSchedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.quickmodes.manualTillNextSchedule',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: ['heating', 'ventilation'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.capability',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.capability',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.10.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.10.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.operating.programs.normalHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.normalHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.normalHeating',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.manualTillNextScheduleEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.manualTillNextScheduleEnergySaving',
        timestamp: '2023-03-24T14:29:39.232Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.operating.programs.manualTillNextScheduleHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.operating.programs.manualTillNextScheduleHeating/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.operating.programs.manualTillNextScheduleHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.manualTillNextScheduleHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.manualTillNextScheduleHeating',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: [],
            type: 'array',
          },
          timeout: {
            value: 120,
            unit: '',
            type: 'number',
          },
        },
        commands: {
          addDevice: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/device.zigbee.coordinator/commands/addDevice',
            name: 'addDevice',
            isExecutable: true,
            params: {
              id: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 16,
                },
              },
              ic: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 36,
                },
              },
              type: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['cs', 'fht', 'repeater', 'trv', 'remoteController', 'airQualitySensor'],
                },
              },
            },
          },
          removeDevice: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/device.zigbee.coordinator/commands/removeDevice',
            name: 'removeDevice',
            isExecutable: true,
            params: {
              id: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 16,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/device.zigbee.coordinator',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.coordinator',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.comfortEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.comfortEnergySaving',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 18,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.reduced.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.temperature.levels.reduced.heating',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 22,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.temperature.levels.comfort.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.temperature.levels.comfort.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          enabled: {
            value: ['0', '1'],
            type: 'array',
          },
        },
        commands: {
          add: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others/commands/add',
            name: 'add',
            isExecutable: false,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
              heatingCircuit: {
                type: 'number',
                required: true,
                constraints: {
                  enum: [],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others',
        gatewayId: gatewaySerial,
        feature: 'rooms.others',
        timestamp: '2023-03-26T04:06:39.050Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.opd.activity',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.opd.activity',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          actors: {
            value: [
              {
                deviceId: 'zigbee-804b50fffea21166',
              },
              {
                deviceId: 'zigbee-000b57fffeca9dc1-1',
              },
              {
                deviceId: 'zigbee-000b57fffeca9dc1-2',
              },
            ],
            type: 'array',
          },
          type: {
            value: 'hallway',
            type: 'string',
          },
          name: {
            value: 'Hallway',
            type: 'string',
          },
        },
        commands: {
          addActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0/commands/addActor',
            name: 'addActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              heatingCircuit: {
                type: 'number',
                constraints: {},
                required: false,
              },
            },
          },
          moveActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0/commands/moveActor',
            name: 'moveActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
              heatingCircuit: {
                type: 'number',
                constraints: {},
                required: false,
              },
              newRoomId: {
                type: 'number',
                constraints: {},
                required: true,
              },
            },
          },
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\p{L}0-9]+( [\\p{L}0-9]+)*$',
                  minLength: 1,
                  maxLength: 40,
                },
              },
            },
          },
          setType: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0/commands/setType',
            name: 'setType',
            isExecutable: true,
            params: {
              type: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'bathroom',
                    'bedroom',
                    'hallway',
                    'livingroom',
                    'kitchen',
                    'office',
                    'nursery',
                    'toilet',
                    'other',
                  ],
                },
              },
            },
          },
          removeActor: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0/commands/removeActor',
            name: 'removeActor',
            isExecutable: true,
            params: {
              actorDeviceId: {
                type: 'string',
                constraints: {},
                required: true,
              },
            },
          },
          remove: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0/commands/remove',
            name: 'remove',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0',
        gatewayId: gatewaySerial,
        feature: 'rooms.0',
        timestamp: '2023-03-26T04:06:42.259Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.configuration.hydraulicBalancing/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {},
                type: 'boolean',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.configuration.hydraulicBalancing',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.configuration.hydraulicBalancing',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '08:30',
                  position: 0,
                },
                {
                  mode: 'normal',
                  start: '15:30',
                  end: '22:40',
                  position: 1,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '08:30',
                  position: 0,
                },
                {
                  mode: 'normal',
                  start: '15:30',
                  end: '22:40',
                  position: 1,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '08:30',
                  position: 0,
                },
                {
                  mode: 'normal',
                  start: '15:30',
                  end: '22:40',
                  position: 1,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '08:30',
                  position: 0,
                },
                {
                  mode: 'normal',
                  start: '15:30',
                  end: '22:40',
                  position: 1,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '08:30',
                  position: 0,
                },
                {
                  mode: 'normal',
                  start: '15:30',
                  end: '22:40',
                  position: 1,
                },
              ],
              sat: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '08:30',
                  position: 0,
                },
                {
                  mode: 'normal',
                  start: '15:30',
                  end: '22:40',
                  position: 1,
                },
              ],
              sun: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '08:30',
                  position: 0,
                },
                {
                  mode: 'normal',
                  start: '15:30',
                  end: '22:40',
                  position: 1,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.schedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.schedule',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.sensors.humidity',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.sensors.humidity',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.11.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.11.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 24,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.temperature.levels.comfort.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.temperature.levels.comfort.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.sensors.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.sensors.co2',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.schedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.schedule',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            unit: 'celsius',
            value: 22.4,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.sensors.temperature',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.sensors.temperature',
        timestamp: '2023-03-26T09:43:49.367Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        feature: 'rooms.0.control.mode.active',
        gatewayId: gatewaySerial,
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2023-03-26T09:43:49.367Z',
        properties: {
          value: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                constraints: {
                  enum: ['standby', 'heating', 'cooling', 'heatingCooling'],
                },
                required: true,
              },
            },
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.control.mode.active/commands/setMode',
          },
        },
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.control.mode.active',
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 8,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.comfort.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.temperature.levels.comfort.heating',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-26T04:00:07.176Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.operating.programs.reducedHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.reducedHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.reducedHeating',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.sensors.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.sensors.co2',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel0FTDC/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel0FTDC/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel0FTDC',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel0FTDC',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          level: {
            type: 'string',
            value: 'normal',
          },
          demand: {
            type: 'string',
            value: 'energySaving',
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          modifier: {
            type: 'string',
            value: 'none',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.state',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.state',
        timestamp: '2023-03-26T04:00:05.443Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            unit: 'celsius',
            value: 20.5,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.sensors.temperature',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.sensors.temperature',
        timestamp: '2023-03-26T02:47:48.012Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'inactive',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.childLock/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.childLock/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.childLock',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.childLock',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.opd.progress',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.opd.progress',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel2FTDCUseValveInformation/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel2FTDCUseValveInformation/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel2FTDCUseValveInformation',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel2FTDCUseValveInformation',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 20,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.temperature.levels.normal.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.temperature.levels.normal.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.normal.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.normal.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.temperature.levels.normal.perceived',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.6.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.6.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel3FTDC/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel3FTDC/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel3FTDC',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel3FTDC',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.operating.programs.normalHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.normalHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.normalHeating',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.7.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.7.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.16.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.16.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.manualTillNextScheduleEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.manualTillNextScheduleEnergySaving',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          level: {
            type: 'string',
            value: 'normal',
          },
          demand: {
            type: 'string',
            value: 'energySaving',
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          modifier: {
            type: 'string',
            value: 'none',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.state',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.state',
        timestamp: '2023-03-26T04:00:07.177Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.schedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.schedule',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.comfortEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.comfortEnergySaving',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'inactive',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.childLock/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.childLock/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.childLock',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.childLock',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.sensors.temperature',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.sensors.temperature',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            unit: 'percent',
            value: 41,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.sensors.humidity',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.sensors.humidity',
        timestamp: '2023-03-26T08:34:47.712Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.configuration.trvAlgorithmActive/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {},
                type: 'boolean',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.configuration.trvAlgorithmActive',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.configuration.trvAlgorithmActive',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.configuration.trvAlgorithmActive/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {},
                type: 'boolean',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.configuration.trvAlgorithmActive',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.configuration.trvAlgorithmActive',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.standby',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.8.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.8.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.comfortEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.comfortEnergySaving',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.operating.programs.normalHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.normalHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.normalHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.operating.programs.reducedHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.reducedHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.reducedHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel2FTDC/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel2FTDC/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel2FTDC',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel2FTDC',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.configuration.heatUpSpeed/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['verySlow', 'slow', 'moderate', 'normal', 'fast', 'veryFast'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.configuration.heatUpSpeed',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.configuration.heatUpSpeed',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 100,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.opd.progress',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.opd.progress',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.comfort.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.comfort.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.temperature.levels.comfort.perceived',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.sensors.humidity',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.sensors.humidity',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.comfortEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.comfortEnergySaving',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 8,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.operating.programs.comfortHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.operating.programs.comfortHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.operating.programs.comfortHeating',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel0FTDCUseValveInformation/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel0FTDCUseValveInformation/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel0FTDCUseValveInformation',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel0FTDCUseValveInformation',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.manualTillNextScheduleEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.manualTillNextScheduleEnergySaving',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.normalEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.normalEnergySaving',
        timestamp: '2023-03-26T06:29:34.197Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          concentration: {
            type: 'number',
            value: 1000,
            unit: 'partsPerMillion',
          },
        },
        commands: {
          setConcentration: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.co2/commands/setConcentration',
            name: 'setConcentration',
            isExecutable: true,
            params: {
              concentration: {
                required: true,
                constraints: {
                  min: 400,
                  max: 1500,
                  stepping: 100,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.co2',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-26T04:00:05.439Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.temperature.levels.normal.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.temperature.levels.normal.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.temperature.levels.normal.perceived',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.opd.activity',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.opd.activity',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.configuration.heatUpSpeed/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['verySlow', 'slow', 'moderate', 'normal', 'fast', 'veryFast'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.configuration.heatUpSpeed',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.configuration.heatUpSpeed',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel3FTDCUseValveInformation/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.features.supplyChannel3FTDCUseValveInformation/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.features.supplyChannel3FTDCUseValveInformation',
        gatewayId: gatewaySerial,
        feature: 'rooms.features.supplyChannel3FTDCUseValveInformation',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.operating.programs.standby',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.sensors.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.sensors.co2',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-26T06:29:34.198Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'normalEnergySaving',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.active',
        timestamp: '2023-03-26T04:00:05.432Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.normalEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.normalEnergySaving',
        timestamp: '2023-03-24T21:39:39.407Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.configuration.trvAlgorithmActive/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {},
                type: 'boolean',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.configuration.trvAlgorithmActive',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.configuration.trvAlgorithmActive',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.configuration.heatUpSpeed/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['verySlow', 'slow', 'moderate', 'normal', 'fast', 'veryFast'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.configuration.heatUpSpeed',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.configuration.heatUpSpeed',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.0.temperature.levels.normal.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.temperature.levels.normal.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.temperature.levels.normal.perceived',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.configuration.hydraulicBalancing/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {},
                type: 'boolean',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.configuration.hydraulicBalancing',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.configuration.hydraulicBalancing',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.normalEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.normalEnergySaving',
        timestamp: '2023-03-26T04:00:05.436Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.operating.programs.manualTillNextScheduleHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.operating.programs.manualTillNextScheduleHeating/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.operating.programs.manualTillNextScheduleHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.manualTillNextScheduleHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.manualTillNextScheduleHeating',
        timestamp: '2023-03-24T14:29:39.233Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 18,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.1.temperature.levels.reduced.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.1.temperature.levels.reduced.heating',
        timestamp: '2023-03-25T16:20:06.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          enabled: {
            value: ['0', '2', '3'],
            type: 'array',
          },
        },
        commands: {
          add: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms/commands/add',
            name: 'add',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 40,
                  regEx: '^[\\p{L}0-9]+( [\\p{L}0-9]+)*$',
                },
              },
              type: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'bathroom',
                    'bedroom',
                    'hallway',
                    'livingroom',
                    'kitchen',
                    'office',
                    'nursery',
                    'toilet',
                    'other',
                  ],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms',
        gatewayId: gatewaySerial,
        feature: 'rooms',
        timestamp: '2023-03-26T04:06:38.928Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.opd.progress',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.opd.progress',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.configuration.hydraulicBalancing/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {},
                type: 'boolean',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.configuration.hydraulicBalancing',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.configuration.hydraulicBalancing',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            unit: 'celsius',
            value: 20.4,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.sensors.temperature',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.sensors.temperature',
        timestamp: '2023-03-26T09:35:47.842Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.quickmodes.manualTillNextSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.quickmodes.manualTillNextSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.quickmodes.manualTillNextSchedule/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.quickmodes.manualTillNextSchedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.quickmodes.manualTillNextSchedule',
        timestamp: '2023-03-23T11:39:30.911Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.15.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.15.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 24,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.operating.programs.comfortHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.operating.programs.comfortHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.operating.programs.comfortHeating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          level: {
            type: 'string',
            value: 'reduced',
          },
          demand: {
            type: 'string',
            value: 'energySaving',
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          modifier: {
            type: 'string',
            value: 'none',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.state',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.state',
        timestamp: '2023-03-24T21:39:39.408Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.operating.programs.manualTillNextScheduleHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.operating.programs.manualTillNextScheduleHeating/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.3.operating.programs.manualTillNextScheduleHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.operating.programs.manualTillNextScheduleHeating',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.operating.programs.manualTillNextScheduleHeating',
        timestamp: '2023-03-23T11:39:30.911Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.17.condensationRisk',
        gatewayId: gatewaySerial,
        feature: 'rooms.17.condensationRisk',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            type: 'number',
            value: 18,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.temperature.levels.reduced.heating',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.temperature.levels.reduced.heating',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.quickmodes.manualTillNextSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.quickmodes.manualTillNextSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.quickmodes.manualTillNextSchedule/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: false,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.quickmodes.manualTillNextSchedule',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.quickmodes.manualTillNextSchedule',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          reason: {
            type: 'string',
            value: 'noDemand',
          },
          demand: {
            type: 'string',
            value: 'unknown',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.operating.programs.manualTillNextScheduleEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'rooms.0.operating.programs.manualTillNextScheduleEnergySaving',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.normal.perceived/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.others.0.temperature.levels.normal.perceived',
        gatewayId: gatewaySerial,
        feature: 'rooms.others.0.temperature.levels.normal.perceived',
        timestamp: '2023-03-25T16:20:06.190Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.sensors.co2',
        gatewayId: gatewaySerial,
        feature: 'rooms.3.sensors.co2',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        properties: {
          status: {
            value: 'inactive',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.childLock/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/RoomControl-1/features/rooms.2.childLock/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.childLock',
        gatewayId: gatewaySerial,
        feature: 'rooms.2.childLock',
        timestamp: '2023-03-23T11:39:08.843Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'RoomControl-1',
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2023-03-25T19:22:57.621Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.0.aggregatedStatus',
        feature: 'rooms.0.aggregatedStatus',
        deviceId: 'RoomControl-1',
        gatewayId: gatewaySerial,
        commands: {},
        properties: {
          status: {
            value: 'MaintenanceNeeded',
            type: 'string',
          },
        },
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2023-03-26T10:05:13.257Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.2.aggregatedStatus',
        feature: 'rooms.2.aggregatedStatus',
        deviceId: 'RoomControl-1',
        gatewayId: gatewaySerial,
        commands: {},
        properties: {
          status: {
            value: 'WorksProperly',
            type: 'string',
          },
        },
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2023-03-26T09:32:19.618Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/RoomControl-1/features/rooms.3.aggregatedStatus',
        feature: 'rooms.3.aggregatedStatus',
        deviceId: 'RoomControl-1',
        gatewayId: gatewaySerial,
        commands: {},
        properties: {
          status: {
            value: 'WorksProperly',
            type: 'string',
          },
        },
      },
      {
        properties: { active: { value: false, type: 'boolean' } },
        commands: {
          activate: {
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-1/features/fht.valve.burnInMode',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve.burnInMode',
        timestamp: '2023-03-23T11:39:08.779Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-1',
      },
      {
        properties: {
          family: { type: 'number', value: 66, unit: '' },
          version: { type: 'number', value: 1, unit: '' },
          revision: { type: 'number', value: 34, unit: '' },
          build: { type: 'number', value: 0, unit: '' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-1/features/device.firmware.version',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.firmware.version',
        timestamp: '2023-03-25T16:20:08.198Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-1',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-1/features/device.otherRoomId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.otherRoomId',
        timestamp: '2023-03-26T04:06:39.053Z',
        isEnabled: false,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-1',
      },
      {
        properties: { type: { value: 'normallyClosed', type: 'string' } },
        commands: {
          setType: {
            uri: '',
            name: 'setType',
            isExecutable: false,
            params: {
              type: {
                type: 'string',
                required: true,
                constraints: { enum: ['normallyClosed', 'normallyOpened'] },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-1/features/fht.valve',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve',
        timestamp: '2023-03-23T11:39:08.779Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-1',
      },
      {
        properties: { value: { type: 'number', value: 0, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-1/features/fht.valve.position',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve.position',
        timestamp: '2023-03-25T16:20:08.198Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-1',
      },
      {
        properties: { value: { value: 0, unit: '', type: 'number' } },
        commands: {
          setId: {
            uri: '',
            name: 'setId',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: -1, max: 23, stepping: 1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-1/features/device.roomId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.roomId',
        timestamp: '2023-03-26T04:06:39.063Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-1',
      },
      {
        properties: { status: { type: 'string', value: 'closed' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-1/features/fht.valve.state',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve.state',
        timestamp: '2023-03-26T09:59:16.785Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-1',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-2/features/device.otherRoomId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.otherRoomId',
        timestamp: '2023-03-26T04:06:39.054Z',
        isEnabled: false,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-2',
      },
      {
        properties: { status: { type: 'string', value: 'closed' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-2/features/fht.valve.state',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve.state',
        timestamp: '2023-03-26T10:01:37.766Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-2',
      },
      {
        properties: { type: { value: 'normallyOpened', type: 'string' } },
        commands: {
          setType: {
            uri: '',
            name: 'setType',
            isExecutable: true,
            params: {
              type: {
                type: 'string',
                required: true,
                constraints: { enum: ['normallyClosed', 'normallyOpened'] },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-2/features/fht.valve',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve',
        timestamp: '2023-03-23T11:39:08.804Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-2',
      },
      {
        properties: {
          family: { type: 'number', value: 66, unit: '' },
          version: { type: 'number', value: 1, unit: '' },
          revision: { type: 'number', value: 34, unit: '' },
          build: { type: 'number', value: 0, unit: '' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-2/features/device.firmware.version',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.firmware.version',
        timestamp: '2023-03-25T16:20:08.217Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-2',
      },
      {
        properties: { value: { type: 'number', value: 0, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-2/features/fht.valve.position',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve.position',
        timestamp: '2023-03-25T16:20:08.217Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-2',
      },
      {
        properties: { active: { value: false, type: 'boolean' } },
        commands: {
          activate: {
            uri: '',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri: '',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-2/features/fht.valve.burnInMode',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.valve.burnInMode',
        timestamp: '2023-03-23T11:39:08.804Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-2',
      },
      {
        properties: { value: { value: 0, unit: '', type: 'number' } },
        commands: {
          setId: {
            uri: '',
            name: 'setId',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: -1, max: 23, stepping: 1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1-2/features/device.roomId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.roomId',
        timestamp: '2023-03-26T04:06:39.064Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1-2',
      },
      {
        properties: { value: { type: 'string', value: 'standby' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/fht.operating.modes.active',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.operating.modes.active',
        timestamp: '2023-03-25T16:20:08.170Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { status: { type: 'string', value: 'connected' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/device.connection',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.connection',
        timestamp: '2023-03-25T16:20:08.170Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { triggered: { type: 'boolean', value: false } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/device.identification',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.identification',
        timestamp: '2023-03-25T16:20:08.170Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { value: { value: 1, type: 'number' } },
        commands: {
          unassignHeatingCircuit: {
            uri: '',
            name: 'unassignHeatingCircuit',
            isExecutable: true,
            params: {},
          },
          assignHeatingCircuit: {
            uri: '',
            name: 'assignHeatingCircuit',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: 0, max: 3, stepping: 1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/device.heatingCircuitId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.heatingCircuitId',
        timestamp: '2023-03-23T11:39:08.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: {
          family: { type: 'number', value: 66, unit: '' },
          version: { type: 'number', value: 1, unit: '' },
          revision: { type: 'number', value: 34, unit: '' },
          build: { type: 'number', value: 0, unit: '' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/device.firmware.version',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.firmware.version',
        timestamp: '2023-03-25T16:20:08.170Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: { new: [], current: [], gone: [] },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/device.errors.active',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.errors.active',
        timestamp: '2023-03-23T11:23:17.201Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: {
          value: { unit: 'celsius', value: 21.5, type: 'number' },
          status: { value: 'connected', type: 'string' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/fht.sensors.temperature.supply',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.sensors.temperature.supply',
        timestamp: '2023-03-26T10:05:52.979Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { entries: { type: 'array', value: [] } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/device.messages.errors.raw',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.messages.errors.raw',
        timestamp: '2023-03-25T16:20:08.170Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { active: { type: 'boolean', value: true } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/fht.operating.modes.standby',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.operating.modes.standby',
        timestamp: '2023-03-25T16:20:08.171Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { strength: { type: 'number', value: 95, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/device.zigbee.lqi',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.zigbee.lqi',
        timestamp: '2023-03-25T16:20:08.170Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { active: { type: 'boolean', value: false } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/fht.operating.modes.heating',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.operating.modes.heating',
        timestamp: '2023-03-25T16:20:08.171Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { active: { type: 'boolean', value: false } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/fht.operating.modes.cooling',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.operating.modes.cooling',
        timestamp: '2023-03-25T16:20:08.171Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { value: { unit: 'celsius', value: 55, type: 'number' } },
        commands: {
          setValue: {
            uri: '',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: 0, max: 65, stepping: 0.1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-000b57fffeca9dc1/features/fht.configuration.floorHeatingDamageProtectionThreshold',
        gatewayId: '7736170-gw-serial-17',
        feature: 'fht.configuration.floorHeatingDamageProtectionThreshold',
        timestamp: '2023-03-23T11:39:08.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-000b57fffeca9dc1',
      },
      {
        properties: { position: { type: 'number', value: 0, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/trv.valve.position',
        gatewayId: '7736170-gw-serial-17',
        feature: 'trv.valve.position',
        timestamp: '2023-03-26T05:16:15.767Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { active: { type: 'boolean', value: false } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/trv.mountingMode',
        gatewayId: '7736170-gw-serial-17',
        feature: 'trv.mountingMode',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { level: { type: 'number', value: 59, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.power.battery',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.power.battery',
        timestamp: '2023-03-26T09:32:19.618Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: { new: [], current: [], gone: [] },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.errors.active',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.errors.active',
        timestamp: '2023-03-23T11:23:12.049Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { status: { type: 'string', value: 'connected' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.connection',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.connection',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { strength: { type: 'number', value: 90, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.zigbee.lqi',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.zigbee.lqi',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { entries: { type: 'array', value: [] } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.messages.errors.raw',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.messages.errors.raw',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { status: { type: 'string', value: 'inactive' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/trv.childLock',
        gatewayId: '7736170-gw-serial-17',
        feature: 'trv.childLock',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: {
          family: { type: 'number', value: 65, unit: '' },
          version: { type: 'number', value: 1, unit: '' },
          revision: { type: 'number', value: 16, unit: '' },
          build: { type: 'number', value: 8, unit: '' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.firmware.version',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.firmware.version',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { value: { value: 3, unit: '', type: 'number' } },
        commands: {
          setId: {
            uri: '',
            name: 'setId',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: -1, max: 23, stepping: 1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.roomId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.roomId',
        timestamp: '2023-03-26T04:06:39.057Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { value: { value: 0, type: 'number' } },
        commands: {
          unassignHeatingCircuit: {
            uri: '',
            name: 'unassignHeatingCircuit',
            isExecutable: true,
            params: {},
          },
          assignHeatingCircuit: {
            uri: '',
            name: 'assignHeatingCircuit',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: 0, max: 3, stepping: 1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.heatingCircuitId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.heatingCircuitId',
        timestamp: '2023-03-23T11:39:08.814Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: {
          value: { type: 'boolean', value: false },
          status: { type: 'string', value: 'connected' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/trv.sensors.openWindow',
        gatewayId: '7736170-gw-serial-17',
        feature: 'trv.sensors.openWindow',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { orientation: { value: 'normal', type: 'string' } },
        commands: {
          setOrientation: {
            uri: '',
            name: 'setOrientation',
            isExecutable: true,
            params: {
              orientation: {
                type: 'string',
                required: true,
                constraints: { enum: ['normal', 'reverted'] },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/trv.display',
        gatewayId: '7736170-gw-serial-17',
        feature: 'trv.display',
        timestamp: '2023-03-23T11:39:08.814Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { triggered: { type: 'boolean', value: false } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.identification',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.identification',
        timestamp: '2023-03-25T16:20:07.675Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: {
          value: { unit: 'celsius', value: 20.4, type: 'number' },
          status: { value: 'connected', type: 'string' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/device.sensors.temperature',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.sensors.temperature',
        timestamp: '2023-03-26T03:00:03.217Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { value: { value: 20, unit: 'celsius', type: 'number' } },
        commands: {
          setTargetTemperature: {
            uri: '',
            name: 'setTargetTemperature',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: { min: 8, max: 30, stepping: 0.5 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-84fd27fffed06d66/features/trv.temperature',
        gatewayId: '7736170-gw-serial-17',
        feature: 'trv.temperature',
        timestamp: '2023-03-26T04:00:21.781Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-84fd27fffed06d66',
      },
      {
        properties: { strength: { type: 'number', value: 88, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.zigbee.lqi',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.zigbee.lqi',
        timestamp: '2023-03-26T01:00:10.220Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: { status: { type: 'string', value: 'connected' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.connection',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.connection',
        timestamp: '2023-03-25T16:20:07.913Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: { triggered: { type: 'boolean', value: false } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.identification',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.identification',
        timestamp: '2023-03-25T16:20:07.913Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: { new: [], current: [], gone: [] },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.errors.active',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.errors.active',
        timestamp: '2023-03-23T11:23:14.317Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: {
          value: { unit: 'percent', value: 41, type: 'number' },
          status: { value: 'connected', type: 'string' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.sensors.humidity',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.sensors.humidity',
        timestamp: '2023-03-26T08:33:53.597Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: {
          family: { type: 'number', value: 67, unit: '' },
          version: { type: 'number', value: 2, unit: '' },
          revision: { type: 'number', value: 5, unit: '' },
          build: { type: 'number', value: 0, unit: '' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.firmware.version',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.firmware.version',
        timestamp: '2023-03-25T16:20:07.913Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: {
          value: { unit: 'celsius', value: 22.3, type: 'number' },
          status: { value: 'connected', type: 'string' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.sensors.temperature',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.sensors.temperature',
        timestamp: '2023-03-26T10:09:13.498Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: { entries: { type: 'array', value: [] } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.messages.errors.raw',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.messages.errors.raw',
        timestamp: '2023-03-25T16:20:07.913Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },

      {
        properties: {},
        commands: {
          unassignHeatingCircuit: {
            uri: '',
            name: 'unassignHeatingCircuit',
            isExecutable: false,
            params: {},
          },
          assignHeatingCircuit: {
            uri: '',
            name: 'assignHeatingCircuit',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: 0, max: 3, stepping: 1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.heatingCircuitId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.heatingCircuitId',
        timestamp: '2023-03-23T11:39:08.793Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: { value: { value: 0, unit: '', type: 'number' } },
        commands: {
          setId: {
            uri: '',
            name: 'setId',
            isExecutable: true,
            params: {
              value: {
                type: 'number',
                required: true,
                constraints: { min: -1, max: 23, stepping: 1 },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.roomId',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.roomId',
        timestamp: '2023-03-26T04:06:39.061Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
      {
        properties: { level: { type: 'number', value: 15, unit: 'percent' } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/zigbee-804b50fffea21166/features/device.power.battery',
        gatewayId: '7736170-gw-serial-17',
        feature: 'device.power.battery',
        timestamp: '2023-03-25T19:22:57.621Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'zigbee-804b50fffea21166',
      },
    ];
  }
}
